module.exports = __webpack_public_path__ + "img/2-gallery.dcea7af9.jpg";